<script lang="ts">
    import { _ } from 'svelte-i18n';

    import src from './svg/lock_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    import IconPending from './IconPending.svelte';
    export let scale: number = 1;
    export let disabled: boolean = false;
</script>

{#if disabled}
    <IconPending {scale} spin={true} />
{:else}
    <TemplateIcon
        {src}
        {scale}
        hover={$_('Route is locked')}
        alt={$_('Route is locked')}
        on:click
    />
{/if}
